import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=3af0f45a&scoped=true&"
import script from "./NewsPage.vue?vue&type=script&lang=ts&"
export * from "./NewsPage.vue?vue&type=script&lang=ts&"
import style0 from "./NewsPage.vue?vue&type=style&index=0&id=3af0f45a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af0f45a",
  null
  
)

export default component.exports